import Overview from "@components/Coronavirus/Overview";
import Section from "@components/Coronavirus/Section";
import {NextPage} from "next";
import {useTranslation} from "ni18n";
import React from "react";
import {useCoronavirusConstants} from "src/constants/CoronavirusConstants";

import Layout from "../components/v5/Layout";

const Coronavirus: NextPage = () => {
  const i18n = useTranslation();
  const pageTitle = i18n.t("Coronavirus resources for testing, vaccines, safe travel & more");
  const pageDescription = i18n.t(
    "Explore Carbon Health’s COVID-19 tools and offerings for staying safe and healthy as the coronavirus pandemic continues to shift and change over time.",
  );
  const pageImage = "coronavirus";

  const sections = useCoronavirusConstants();

  return (
    <Layout pageTitle={pageTitle} pageDescription={pageDescription} pageImage={pageImage}>
      <Overview sections={sections} />
      <div className="ph4 pt8 pt4-md pb20">
        <div className="maxw72 ma dg gafr gg12 gg6-md jcc-md">
          {sections.map(section => (
            <Section key={section.id} section={section} />
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Coronavirus;
